import React from "react";
import { useTranslation } from "react-i18next";

interface GridTableCouponsProps {
  children: React.ReactNode;
}

const headers = [
  "code",
  "amount",
  "startDate",
  "endDate",
  "limit",
  "maxUserUsage",
  "activate",
  "actions"
];

const GridTableCoupons: React.FC<GridTableCouponsProps> = ({ children }) => {
const { t, i18n } = useTranslation();
  const lang = i18n.language;
  
  const isRtl = lang === "ar";

  return (
    <div className="thin-scrollbar overflow-x-auto rounded-lg">
      <table className="min-w-full table-auto">
        <colgroup>
          <col style={{ width: "30%" }} />
          <col style={{ width: "25%" }} />
          <col style={{ width: "25%" }} />
          <col style={{ width: "25%" }} />
          <col style={{ width: "6%" }} />
          <col style={{ width: "6%" }} />
          <col style={{ width: "7%" }} />
          <col style={{ width: "6%" }} />
        </colgroup>
        <thead className="bg-gray-100">
          <tr>
            {headers.map(( index) => (
              <th
                key={index}
                className={`px-6 py-3 text-sm font-semibold capitalize tracking-wider text-gray-700 text-nowrap  ${
                  isRtl ? "text-right" : "text-left"
                }`}
              >
                {t(`couponsTable.${index}`)}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};

export default GridTableCoupons;
